import React, { Component } from "react";
import BaseModal from "./base_modal";
import { Button, Col, Grid, Row } from "react-bootstrap";
import { hideModal } from "../../actions/modal";
import { connect } from "react-redux";
import Divider from "../lib/divider";
import "./monetization_intro_modal/promotions-intro-modal.scss";
import FormElement from "../forms/form_element";
import { clearDealValidationErrors, createDeal } from "../../action_managers/deals";
import { withRouter } from "react-router";
import get from "lodash/get";
import LoadingButton from "../forms/loading_button/loading_button";
import { If } from "react-extras";
import ConfirmationModal from "./confirmation_modal";

const confirmationMessage = `Great job, your proposal has been sent. 
  You can continue to add more details to your proposal by clicking the View Proposal button.
  Otherwise, click Cancel to continue browsing.`;

class DealCreateModal extends Component {
  state = {
    message: null,
    showConfirmationModal: false,
    dealUUID: null,
  };

  componentDidMount() {
    this.props.clearDealValidationErrors();
  }

  createDeal = () => {
    this.props
      .createDeal(this.props.recipientUUID, this.state.message, this.props.showUUID)
      .then(response => {
        if (response.status === 200) {
          const dealUUID = get(response, "json.uuid");
          this.setState({ showConfirmationModal: true, dealUUID: dealUUID });
        }
      });
  };

  modalContent = () => {
    return (
      <Grid fluid>
        <Row>
          <Col xs={12} xsOffset={0} md={10} mdOffset={1}>
            <div className="deal-create-modal__intro">
              Introduce yourself, say a little something about your podcast, and why you think it’d
              be a good idea to run a cross promotion together.
            </div>
            <Divider />
            <FormElement
              className="deal-create-modal__message"
              name="message"
              validationErrorKeyOverride="messageText"
              label="Message"
              type="textarea"
              rows="5"
              onChange={e => {
                this.setState({ message: e.target.value });
              }}
              componentClass="textarea"
              validationErrors={this.props.validationErrors}
            />
            <div className="deal-create-modal__spacer" />
          </Col>
        </Row>
        <Row>
          <Col xs={10} xsOffset={1}>
            <div className="mini-modal-footer">
              <Row>
                <Col xs={6}>
                  <Button className="btn btn-secondary" onClick={this.props.hideModal}>
                    Cancel
                  </Button>
                </Col>
                <Col xs={6}>
                  <LoadingButton
                    isLoading={this.props.isLoading}
                    className="btn btn-primary"
                    onClick={this.createDeal}>
                    Send
                    <span className="hidden-xs"> Message</span>
                  </LoadingButton>
                </Col>
              </Row>
            </div>
          </Col>
        </Row>
      </Grid>
    );
  };

  closeModal = () => {
    this.setState({ showConfirmationModal: false }, this.props.hideModal);
  };

  gotoDealPage = dealUUID => {
    this.props.history.push(`/promotions/deals/${dealUUID}/`);
  };

  render() {
    return (
      <>
        <If condition={!this.state.showConfirmationModal}>
          <BaseModal
            isLoading={false}
            isMini={true}
            columns={10}
            offset={1}
            title={"Cross Promotion Proposal"}
            close={this.props.hideModal}
            hideCloseButton={false}
            showContent={true}
            Content={this.modalContent}
          />
        </If>
        <If condition={this.state.showConfirmationModal}>
          <ConfirmationModal
            closeModal={this.closeModal}
            callback={this.gotoDealPage.bind(this, this.state.dealUUID)}
            actionButtonName="View Proposal"
            confirmationMessage={confirmationMessage}
            modalTitle="Proposal Sent!"
          />
        </If>
      </>
    );
  }
}

export default withRouter(
  connect(
    ({ user, deals }) => ({
      user,
      validationErrors: get(deals, "validationErrors", []),
      isLoading: get(deals, "isLoading"),
    }),
    {
      hideModal,
      createDeal,
      clearDealValidationErrors,
    }
  )(DealCreateModal)
);
